import { useParams, useNavigate } from 'react-router-dom';
import { useAppStore } from '../hooks/useAppStore';
import { ArrowLeft, CheckCircle } from 'lucide-react';
import * as Icons from 'lucide-react';

export default function TopicDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const { topics, updateAnswer, markComplete } = useAppStore();
  const topic = topics.find(t => t.id === id);
  if (!topic) return <div className="p-8 text-center text-gray-500">Topic not found</div>;

  const Icon = Icons[topic.icon] || Icons.Circle;
  const allAnswered = topic.questions.every(q => (topic.answers[q.id] || '').trim());

  return (
    <div className="px-4 py-5 pb-32 animate-fade-in">
      <button onClick={() => nav(-1)} className="flex items-center gap-2 text-sm text-gray-400 hover:text-gray-200 mb-5 transition-colors"><ArrowLeft size={18} />Back</button>

      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{background:`${topic.color}15`,border:`1px solid ${topic.color}25`}}>
          <Icon size={24} style={{color:topic.color}} />
        </div>
        <div>
          <h1 className="text-xl font-bold text-gray-100">{topic.name}</h1>
          <p className="text-xs text-gray-500">{topic.desc}</p>
        </div>
        {topic.completed && <CheckCircle size={20} className="text-emerald-500 ml-auto" />}
      </div>

      <div className="space-y-5">
        {topic.questions.map(q => (
          <div key={q.id}>
            <label className="block text-sm text-gray-300 mb-2">{q.text}</label>
            <textarea
              value={topic.answers[q.id] || ''}
              onChange={e => updateAnswer(topic.id, q.id, e.target.value)}
              placeholder={q.ph}
              rows={3}
              className="textarea-bc"
              readOnly={topic.completed}
            />
          </div>
        ))}
      </div>

      {!topic.completed && (
        <div className="fixed bottom-16 inset-x-0 px-4 py-3 backdrop-blur-xl bg-zinc-950/80 border-t border-white/[0.04] safe-bottom">
          <button onClick={() => markComplete(topic.id)} disabled={!allAnswered}
            className="btn-gradient w-full flex items-center justify-center gap-2 rounded-xl px-6 py-3.5 text-sm font-semibold text-white disabled:opacity-30 disabled:cursor-not-allowed">
            <CheckCircle size={18} />Lock & Save
          </button>
        </div>
      )}
    </div>
  );
}
